<template>
  <div class="stats-panel">



    <!--    产品-->
    <template v-if="module==4">
      <!--      产品总数-->
      <div class="stats-panel_name">产品总数</div>
      <FlipCounter :number="GMVform.product_count ? GMVform.product_count - 0 : 0"/>
      <div class="stats-panel_flex">
        <!--        今日gmv-->
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform?.current_sum_pay_amount? GMVform?.current_sum_pay_amount :0 }}</div>
          <div class="stats-panel_flex_box_txt">{{ timeLabelLocal }}GMV</div>
        </div>
        <!--        昨日产品新增-->
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{
              GMVform?.yesterday_product_count ? GMVform?.yesterday_product_count : 0
            }}</div>
          <div class="stats-panel_flex_box_txt">{{ GMVform?.previous_desc }}产品新增</div>
        </div>
        <!--        产品新增环比增长-->
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform?.product_count_ratio ? GMVform?.product_count_ratio : 0 }}%</div>
          <div class="stats-panel_flex_box_txt">产品新增环比增长</div>
        </div>
        <!--        累计交易额-->
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform?.all_sum_pay_amount?GMVform?.all_sum_pay_amount:0 }}</div>
          <div class="stats-panel_flex_box_txt">累计交易额</div>
        </div>
      </div>

    </template>


    <!--商家-->
    <template v-else-if="module==8">
      <div class="stats-panel_name">{{ timeLabelLocal }}GMV</div>
      <FlipCounter :number="GMVform.today_sum_pay_amount ? GMVform.today_sum_pay_amount - 0 : 0"/>
      <div class="stats-panel_flex">
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform.today_product_order}}</div>
          <div class="stats-panel_flex_box_txt">{{ timeLabelLocal }}成交单量</div>
        </div>
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform.today_deliver_order }}</div>
          <div class="stats-panel_flex_box_txt">{{ timeLabelLocal }}已发货单量</div>
        </div>
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform.today_refund_amount }}</div>
          <div class="stats-panel_flex_box_txt">{{ timeLabelLocal }}退款额</div>
        </div>
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform.today_refund_order }}</div>
          <div class="stats-panel_flex_box_txt">{{ timeLabelLocal}}退款单量</div>
        </div>
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform.sum_pay_amount }}</div>
          <div class="stats-panel_flex_box_txt">累计交易额</div>
        </div>
      </div>
    </template>


    <template v-else>
      <div class="stats-panel_name">{{ timeLabelLocal }}GMV</div>
      <FlipCounter :number="GMVform.current_sum_pay_amount ? GMVform.current_sum_pay_amount - 0 : 0"/>
      <div class="stats-panel_flex">
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform?.current_count_order? GMVform?.current_count_order:0 }}</div>
          <div class="stats-panel_flex_box_txt">{{ timeLabelLocal }}付款订单数</div>
        </div>
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform?.previous_sum_pay_amount?GMVform?.previous_sum_pay_amount :0 }}</div>
          <div class="stats-panel_flex_box_txt">{{ GMVform?.previous_desc }} GMV</div>
        </div>
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform?.gmv_growth?GMVform?.gmv_growth:0 }}%</div>
          <div class="stats-panel_flex_box_txt">GMV同比增长</div>
        </div>
        <div class="stats-panel_flex_box">
          <div class="stats-panel_flex_box_num">{{ GMVform?.all_sum_pay_amount ? GMVform?.all_sum_pay_amount : 0}}</div>
          <div class="stats-panel_flex_box_txt">累计交易额</div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import FlipCounter from './components/FlipCounter.vue'

export default {
  components: {
    FlipCounter
  },
  props: {
    module: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    GMVform: {
      type: Object,
      default: {}
    }
  },
  computed: {
    timeLabelLocal() {
      if (this.name == '') return '本时段'
      return this.name;
    }
  },
  watch: {
    GMVform(newVal) {

    }
  }
}
</script>

<style lang="scss" scoped>
.center-content {
  width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stats-panel {
  width: 830px;
  height: 280px;
  background: url(../../../assets/_s-inage_gmv_bg.png) no-repeat;
  background-size: 100% 100%;
}

.stats-panel_name {
  padding-top: 15px;
  font-weight: 600;
  font-size: 28px;
  color: #FFFFFF;
  text-align: center;
}

.stats-panel_flex {
  display: flex;
}

.stats-panel_flex_box {
  width: 25%;
  text-align: center;
}

.stats-panel_flex_box_num {
  margin-top: 15px;
  line-height: 26px;
  font-weight: 400;
  font-size: 26px;
  color: #FEFEFE;
  margin-bottom: 12px;
}

.stats-panel_flex_box_txt {
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  color: #00A8FF;
}
</style>